import {SecurityInformationService} from "./service/SecurityInformationService";
import {SecurityInformationStore} from "./store/SecurityInformationStore";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.security-information`;
    return angular.module(moduleName, [])
                  .service(SecurityInformationService.id, SecurityInformationService)
                  .service(SecurityInformationStore.id, SecurityInformationStore)
                  .name;
}
